import script from "./FamilyGroupScopeModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupScopeModal.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupScopeModal.vue?vue&type=style&index=0&id=79fa1782&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79fa1782"]])

export default __exports__